export default "__VITE_ASSET__ydF_Zsk2__"